import { yup } from '@guiker/yup-util'

export const updateInquiryOptionIdSchema = yup.object({
  listingId: yup.string().required(),
  rentalOptionId: yup.string().required(),
})

export type UpdateInquiryOptionIdSchema = yup.InferType<typeof updateInquiryOptionIdSchema>
